module.exports = __webpack_public_path__ + "img/女-高血压h.de62acf4.png";